import { HeaderItem } from '@root/component/table-fixed-header/table-fixed-header.component';

interface CleanOptionInterface {
  label: string;
  value: number;
  i18nKey: string;
}

export const TaskTypeList: Array<CleanOptionInterface> = [
  {
    label: '不限',
    i18nKey: 'task.word.any',
    value: null,
  },
  {
    label: '保洁',
    i18nKey: 'task.word.cleaning',
    value: 0,
  },
  {
    label: '维护',
    i18nKey: 'task.word.maintenance',
    value: 1,
  },
  {
    label: '接待',
    i18nKey: 'task.word.reception',
    value: 2,
  },
  {
    label: '客房服务',
    i18nKey: 'task.word.room_service',
    value: 3,
  },
  {
    label: '其他',
    i18nKey: 'task.word.other',
    value: 4,
  },
];

export const CleanLevelList: Array<CleanOptionInterface> = [
  {
    label: '不限',
    i18nKey: 'task.word.any',
    value: -1,
  },
  {
    label: '标准',
    i18nKey: 'task.fee.standard',
    value: 0,
  },
  {
    label: '简单',
    i18nKey: 'task.fee.simple',
    value: 1,
  },
  {
    label: '高级',
    i18nKey: 'task.fee.advanced',
    value: 2,
  },
];

export const CleanStatusList: Array<CleanOptionInterface> = [
  {
    label: '不限',
    i18nKey: 'task.word.any',
    value: null,
  },
  {
    label: '未完成',
    i18nKey: 'task.list.pending',
    value: 0,
  },
  {
    label: '进行中',
    i18nKey: 'task.list.ongoing',
    value: 1,
  },
  {
    label: '已完成',
    i18nKey: 'task.list.completed',
    value: 2,
  },
];

export const HeaderListForTask = [
  [
    { name: '类型', i18nName: 'task.word.type.text', width: '8%', align: 'left' },
    {
      name: '被分配人',
      i18nName: 'task.word.assignee',
      width: '8%',
      align: 'left',
    },
    {
      name: '房间',
      i18nName: 'task.word.property',
      width: '18%',
      align: 'left',
    },
    {
      name: '时间',
      i18nName: 'task.word.time',
      width: '12%',
      sortable: true,
      field: 'time',
      align: 'left',
    },
    { name: '费用', i18nName: 'task.word.fee', width: '8%', align: 'left' },
    {
      name: '状态',
      i18nName: 'task.filter.status',
      width: '8%',
      align: 'left',
    },
    {
      name: '描述',
      i18nName: 'task.word.description',
      width: '15%',
      align: 'left',
    },
    {
      name: '反馈',
      i18nName: 'task.list.feedback',
      width: '15%',
      align: 'left',
    },
  ],
];

export const ListWidthConfig = [
  '8%',
  '8%',
  '18%',
  '12%',
  '8%',
  '8%',
  '15%',
  '15%',
];

export const HeaderListForFee: Array<HeaderItem> = [
  { name: '房间', i18nName: 'task.fee.property', width: 150 },
  { name: '房型', i18nName: 'task.fee.room_type', width: 150 },
  { name: '分组', i18nName: 'task.fee.group', width: 80 },
  { name: '简单', i18nName: 'task.fee.simple', width: 80 },
  { name: '标准', i18nName: 'task.fee.standard', width: 80 },
  { name: '高级', i18nName: 'task.fee.advanced', width: 80 },
  { name: '币种', i18nName: 'task.fee.currency', width: 80 },
  { name: '操作', i18nName: 'task.fee.operation', width: 80 },
];

export const HeaderListForDate: Array<HeaderItem> = [
  { name: '时间', i18nName: 'task.statistics.date', width: 100 },
  { name: '入住数', i18nName: 'task.statistics.checkins', width: 100 },
  { name: '退房数', i18nName: 'task.statistics.checkouts', width: 100 },
  { name: '任务数', i18nName: 'task.statistics.tasks', width: 100 },
  { name: '费用', width: 100 },
];

export const HeaderListForStaff: Array<HeaderItem> = [
  { name: '人员', i18nName: 'task.statistics.staff', width: 100 },
  { name: '任务数', i18nName: 'task.statistics.tasks', width: 100 },
  { name: '费用', width: 100 },
];

export const HeaderListForHouse: Array<HeaderItem> = [
  { name: '房间', i18nName: 'task.statisitics.property', width: 150 },
  { name: '入住数', i18nName: 'task.statistics.checkins', width: 100 },
  { name: '退房数', i18nName: 'task.statistics.checkouts', width: 100 },
  { name: '任务数', i18nName: 'task.statistics.tasks', width: 100 },
  { name: '费用', width: 100 },
];
